import safeCreateAction from "../../../actions/safeCreateAction";
import { UserCanceled } from "../../../util/CustomErrors";
import { changeToEntry } from "../util/externalChanges";
/**
 * sets the updating mods flag
 */
export const setUpdatingMods = safeCreateAction("SET_UPDATING_MODS", (gameId, updatingMods) => ({ gameId, updatingMods }));
export const setDeploymentProblem = safeCreateAction("SET_DEPLOYMENT_PROBLEM", (errors) => errors);
/**
 * stores info about files that were changed outside the control of Vortex. The user
 * will be asked how to deal with them
 */
export const setExternalChanges = safeCreateAction("SET_EXTERNAL_CHANGES", (entries) => entries);
export const setExternalChangeAction = safeCreateAction("SET_EXTERNAL_CHANGE_ACTION", (filePaths, action) => ({ filePaths, action }));
let curResolve;
let curReject;
export function showExternalChanges(changes) {
    return (dispatch) => new Promise((resolve, reject) => {
        curResolve = resolve;
        curReject = reject;
        const entries = [];
        Object.keys(changes).forEach((typeId) => {
            changes[typeId].forEach((fileChange) => entries.push(changeToEntry(typeId, fileChange)));
        });
        dispatch(setExternalChanges(entries));
    });
}
export function confirmExternalChanges(changes, canceled) {
    return (dispatch) => {
        if (canceled) {
            if (curReject !== undefined) {
                curReject(new UserCanceled());
            }
        }
        else {
            if (curResolve !== undefined) {
                curResolve(changes);
            }
        }
        curReject = undefined;
        curResolve = undefined;
        dispatch(setExternalChanges([]));
    };
}
